import https from "@/lib/https";
import type { ApiResponse } from "@/interface/common";
import type { ProfileSkillDetail } from "@/interface/profileSkill";

export interface MyProfileSkill {
  id?: number | string;
  skill_name?: string;
  category?: string;
  proficiency?: string;
  experience_years?: number;
  experience_months?: number;
  [key: string]: any;
}

export interface MyProfileDetail {
  id: number | string;
  username?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  job_role?: string | null;
  skills?: MyProfileSkill[] | ProfileSkillDetail[] | string[];
  experience_years?: number;
  experience_months?: number;
  summary?: string | null;
  updated_at?: string;
  updated_by_name?: string | null;
  status?: string;
  score?: number;
  is_original?: boolean;
  [key: string]: any;
}

export const getMyProfiles = async (): Promise<ApiResponse<MyProfileDetail[]>> => {
  return await https.get<ApiResponse<MyProfileDetail[]>>("/api/profiles/my-profiles/");
};

export const deleteProfile = async (
  id: number | string,
): Promise<ApiResponse<void>> => {
  return await https.delete<ApiResponse<void>>(`/api/profiles/${id}/`);
};

